import axios from "axios";
import { useMutation } from "react-query";

const MainUrl = process.env.REACT_APP_PUBLIC_PATH;
const url = MainUrl + "/api/library/Library/GetAllBooksByFilter"; 

const GetPublicLibraryApi = async (params) => {
  return await axios.post(url, params);
};

export const UseGetLibrary = () => {
  return useMutation(GetPublicLibraryApi);
};